<template>
  <b-modal
    id="dispatch-modal"
    ref="modal"
    :hide-footer="true"
    title="Dispatch Car"
    @hidden="closeModal"
  >
    <b-form @submit.stop.prevent="onSubmit">
      <b-form-group
        id="input-group-driver"
        label="Driver"
        label-for="input-event"
      >
        <b-input
          id="input-event"
          v-model="form.driver"
          disabled
          type="text"
        />
      </b-form-group>
      <b-form-group
        id="input-group-phone"
        label="Phone Number"
        label-for="input-phone"
      >
        <b-input
          id="input-event"
          v-model="form.phone"
          disabled
          type="text"
        />
      </b-form-group>
      <b-form-textarea
        id="textarea"
        v-model="form.message"
        required
        placeholder="Enter message..."
        rows="10"
        max-rows="16"
      />
      <div class="d-flex justify-content-end mt-2">
        <b-button
          type="submit"
          variant="primary"
        >
          Dispatch
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
  export default {
    name: "DispatchModal",
    props: ['open', 'form'],
    data() {
      return {};
    },
    watch: {
      open: function () {
        if (this.open) {
          this.$refs['modal'].show()
        } else {
          this.$refs['modal'].hide()
        }
      }
    },
    methods: {
      async onSubmit(evt) {
        evt.preventDefault();
        try {
          let dispatchResult = await this.$http.post(`bookings/${this.form.bookingId}/dispatch`);
          let result = await this.$http.post(`bookings/${this.form.bookingId}/message`, {message: this.form.message});
          this.successAlert('The dispatch message was successfully sent via Viber.')
        }catch(error){
          this.handleErrorResponse(error);
        }
        this.closeModal();
      },
      closeModal() {
        this.$emit('modal-closed')
      },
    }
  };
</script>

<style lang="scss" scoped>
</style>
